import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-home',
  templateUrl: './about-home.component.html',
  styleUrls: ['../homepage.component.scss']
})
export class AboutHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
